import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	filters: {},
	settings: {
		sealImage: [''],
		fields: [],
		selectedFields: []
	},
	sizeElements: 0,
	courtSettingsToPrint: [],
	tableFiltersRef: {},
	tableSortRef: {}
};

const judgeCalendarSlice = createSlice({
	initialState,
	name: 'JudgeCalendarSlice',
	reducers: {
		clearAll: (state) => {
			state.filters = [];
		},
		addFilters: (state, action) => {
			state.filters = action.payload;
		},
		setSettings: (state, action) => {
			state.settings = action.payload;
		},
		setSizeElements: (state, action) => {
			state.sizeElements = action.payload;
		},
		setCourtSettingsToPrint: (state, action) => {
			state.courtSettingsToPrint = action.payload;
		},
		setTableFiltersRef: (state, action) => {
			state.tableFiltersRef = action.payload;
		},
		setTableSortRef: (state, action) => {
			state.tableSortRef = action.payload;
		}
	}
});

export const {
	clearAll,
	addFilters,
	setSettings,
	setSizeElements,
	setCourtSettingsToPrint,
	setTableFiltersRef,
	setTableSortRef
} = judgeCalendarSlice.actions;

export default judgeCalendarSlice.reducer;
